"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FacebookAboutDataSource = /*#__PURE__*/function () {
  function FacebookAboutDataSource() {
    (0, _classCallCheck2["default"])(this, FacebookAboutDataSource);
  }

  (0, _createClass2["default"])(FacebookAboutDataSource, null, [{
    key: "getName",
    value: function getName() {
      return 'Facebook About';
    }
  }, {
    key: "getItemId",
    value: function getItemId(item) {
      return item.id;
    }
  }, {
    key: "mapResult",
    value: function mapResult(result) {
      return _objectSpread({}, result, {
        description: result.description || result.bio,
        address: result.location,
        coverPhoto: {
          value: result.cover.source
        }
      });
    }
  }, {
    key: "getDataPromise",
    value: function getDataPromise(value, requestBody) {
      var item = [{
        id: 'accountId',
        value: value
      }];
      requestBody.item = item;
      return requestBody;
    }
  }]);
  return FacebookAboutDataSource;
}();

FacebookAboutDataSource.getRequestName = function () {
  return 'FacebookAboutApi';
};

var _default = FacebookAboutDataSource;
exports["default"] = _default;